/**
 * @generated SignedSource<<66677893b7bc58651744fe36eacf7d6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_user$data = {
  readonly recentHistoryItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contemporaryTrackingString: string;
        readonly firstPhotoWebPath: string | null;
        readonly pdpURL: string | null;
        readonly title: string | null;
        readonly browseUrl: string | null;
        readonly categoryCode: string | null;
        readonly serviceId: string | null;
        readonly categoryPath: string | null;
        readonly seller: {
          readonly serviceId: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsFooter_user" | "PdpRespSimilarItemsLanding_user" | "PdpRespSidebarButtons_user" | "PdpRespSidebarBlurbs_user" | "PdpRespShippingReturns_user" | "PdpRespBuyerAssuranceBox_user" | "PdpRespSidebarContact_user" | "PdpRespHeroCarousel_user" | "PdpRespDealerDetails_user" | "PdpRespSidebarSellerInfo_user" | "PdpRespSidebarSellerInfoAndContactLazy_user" | "PdpSharedPromoCode_user" | "PdpRespSwatchSelector_user" | "PdpRespAboutModule_user" | "PdpRespAboutTabs_user" | "PdpRespTopModule_user" | "PdpRespDetailsTabs_user" | "PdpRespSellerItems_user">;
  readonly " $fragmentType": "PdpRespContainer_user";
};
export type PdpRespContainer_user$key = {
  readonly " $data"?: PdpRespContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUserRecentHistoryItem"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpRedesignVariant"
    },
    {
      "kind": "RootArgument",
      "name": "localRecentHistoryItemIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespBuyerAssuranceBox_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContactLazy_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_user"
    },
    {
      "condition": "isPdpRedesignVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespAboutTabs_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTopModule_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetailsTabs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItems_user"
    },
    {
      "condition": "fetchUserRecentHistoryItem",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "recentHistoryItems",
          "args": [
            {
              "kind": "Variable",
              "name": "excludeItemPks",
              "variableName": "localRecentHistoryItemIds"
            }
          ],
          "concreteType": "RecentHistoryItemsConnection",
          "kind": "LinkedField",
          "name": "__getRecentHistory_recentHistoryItems_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecentHistoryItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contemporaryTrackingString",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "size",
                          "value": "small"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "firstPhotoWebPath",
                      "storageKey": "firstPhotoWebPath(size:\"small\")"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pdpURL",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "browseUrl",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "categoryCode",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "categoryPath",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Seller",
                      "kind": "LinkedField",
                      "name": "seller",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "8a46c8d2af911a3130abbc9e16c06499";

export default node;
